import { c as _c } from "react/compiler-runtime";
import { AutoCompleteInput } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/auto-complete-input/auto-complete-input";
import { CityType, CityTypeInitialValue } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/auto-complete-input/types";
import { DatePickerInput } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/date-picker-input/date-picker-input";
import { useSubmit, useValidation } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/hooks";
import { PassengerRoomCountInput } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/PassengerRooomCountInput";
import { PassengersCountType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/passenger-room-count-tour/types";
import { TourSearchPanelPropertiesType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { DatepickerCalendarLocaleType, DatepickerSelectedDateType } from "@website/ui/datepicker";
import { FC, useState } from "react";
export const TourSearchPanel: FC<TourSearchPanelPropertiesType> = properties => {
  const $ = _c(36);
  const {
    dateRange,
    cityFrom,
    cityTo,
    passengers,
    onClose,
    originSuggestions,
    destinationSuggestions,
    page
  } = properties;
  const [selectedOriginItem, setSelectedOriginItem] = useState();
  const [selectedDestinationItem, setSelectedDestinationItem] = useState();
  const [passengerCount, setPassengerCount] = useState();
  const isHomePage = process.env.NEXT_PUBLIC_APP_NAME === "homepage";
  const [date, setDate] = useState();
  const [calendarLocale, setCalendarLocale] = useState();
  const t0 = cityFrom as CityTypeInitialValue;
  const t1 = cityTo as CityTypeInitialValue;
  let t2;
  if ($[0] !== date || $[1] !== selectedDestinationItem || $[2] !== selectedOriginItem || $[3] !== t0 || $[4] !== t1) {
    t2 = {
      originItem: selectedOriginItem,
      destinationItem: selectedDestinationItem,
      initialCityFrom: t0,
      initialCityTo: t1,
      date
    };
    $[0] = date;
    $[1] = selectedDestinationItem;
    $[2] = selectedOriginItem;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    errors,
    submitValidationCheck
  } = useValidation(t2);
  const {
    onSubmitClick,
    submitText
  } = useSubmit(selectedOriginItem, selectedDestinationItem, date, calendarLocale, passengerCount, submitValidationCheck, cityFrom as CityTypeInitialValue, cityTo as CityTypeInitialValue, isHomePage);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (value, calendarLocale_0) => {
      setDate(value);
      setCalendarLocale(calendarLocale_0);
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onChangeDate = t3;
  const t4 = passengers as PassengersCountType;
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="flex h-8 flex-1 flex-row gap-2 overflow-x-auto md:overflow-visible lg:flex-none xl:h-[38px]"><PassengerRoomCountInput onChange={setPassengerCount} passengerInitial={t4} /></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onClose || $[10] !== page) {
    t6 = !isHomePage && <div className={`${page === "homepage" ? "md:hidden" : "md:block"} hidden`}><Button StartIcon={<MaterialIcon name="close" />} color="neutral" onClick={onClose} size="small" variant="text" /></div>;
    $[9] = onClose;
    $[10] = page;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="flex flex-row items-start justify-between gap-6 xl:flex-row xl:items-center">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = destinationSuggestions as Array<CityType>;
  const t9 = originSuggestions as Array<CityType>;
  let t10;
  if ($[15] !== cityFrom || $[16] !== cityTo || $[17] !== errors || $[18] !== t8 || $[19] !== t9) {
    t10 = <div className={`${isHomePage ? "xl:grow-[2]" : "xl:grow-[3]"} lg:grow-[2]`}><AutoCompleteInput cityFromInitial={cityFrom} cityToInitial={cityTo} destinationSuggestions={t8} errors={errors} onChangeDestination={setSelectedDestinationItem} onChangeOrigin={setSelectedOriginItem} originSuggestions={t9} /></div>;
    $[15] = cityFrom;
    $[16] = cityTo;
    $[17] = errors;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = dateRange as DatepickerSelectedDateType;
  let t12;
  if ($[21] !== errors || $[22] !== t11) {
    t12 = <div className="lg:grow"><DatePickerInput dateRangeInitial={t11} errors={errors} onChange={onChangeDate} /></div>;
    $[21] = errors;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t12) {
    t13 = <div className="flex flex-col gap-4 lg:grow lg:flex-row">{t10}{t12}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== onSubmitClick || $[28] !== submitText) {
    t14 = <div className="relative grow lg:grow-0"><Button aria-label="search" className={`${isHomePage ? "static" : "absolute"} bottom-0 max-md:!h-12 lg:static`} fullWidth={true} onClick={onSubmitClick} size="x-large">{submitText}</Button></div>;
    $[27] = onSubmitClick;
    $[28] = submitText;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t13 || $[31] !== t14) {
    t15 = <div className="flex h-full flex-col gap-6 lg:flex-row xl:gap-4">{t13}{t14}</div>;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15 || $[34] !== t7) {
    t16 = <div className={`${isHomePage ? "bg-background xl:w-full" : "px-6 xl:w-[1200px] xl:px-10"} flex h-full flex-col gap-6 xl:mx-auto`} id="tourSearchPanl">{t7}{t15}</div>;
    $[33] = t15;
    $[34] = t7;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};